import {Fragment, useMemo} from 'react';
import {getValidChildren} from '../../../common/shared/utils/getValidChildren';
import {Divider} from '../../atoms/Divider/Divider';
import {List} from '../../atoms/List/List';
import {VerticalListWithDividerProps} from './VerticalListWithDividerProps.interface';

export function VerticalListWithDivider({
  children,
  gapPx = 0,
  dividerSizePx,
  dividerColor,
  shouldShowLastDivider = false,
  ...props
}: VerticalListWithDividerProps) {
  const validChildren = useMemo(() => getValidChildren(children), [children]);

  return (
    <List direction="column" {...props}>
      {validChildren.map((child, idx) => (
        <Fragment
          key={typeof child === 'object' && 'key' in child ? child.key : idx}
        >
          {child}
          {(shouldShowLastDivider || idx !== validChildren.length - 1) && (
            <Divider
              sizePx={dividerSizePx}
              color={dividerColor}
              style={{margin: `${gapPx}px 0`}}
            />
          )}
        </Fragment>
      ))}
    </List>
  );
}
